import React from 'react';
import { Card } from '@usealloy/component-library';

import TagsList from '~/entities/evaluations/TagsList';

import { useEventTypeEvaluationsContext } from '../context';

const OutcomeReasons: React.FC = () => {
  const { evaluation } = useEventTypeEvaluationsContext();
  const reasons = (evaluation?.tags || []).filter(tag => tag.is_outcome_reason);

  if (!reasons?.length) {
    return null;
  }

  return (
    <Card
      header="Outcome Reasons"
      collapsible
    >
      <TagsList
        tags={reasons}
        outcome={evaluation.outcome}
        evaluationTags={evaluation.tags ?? []}
        evaluationToken={evaluation.evaluation_token}
        entityToken={evaluation.entity_token}
        workflowToken={evaluation.application_token}
        workflowVersion={evaluation.public_version}
        includePendoAnchor={false}
      />
    </Card>
  );
};

export default OutcomeReasons;
